/* ==========================================================================
   DS header v2 (Option 1), 29 Oct 2026 - approved by Ash
   - vehicle band: numbered steps, saved "Shopping for" chip, Change, quick links
   - Make + Model is enough: without a sub model, Show parts searches the model
   - phone: band button opens the widget as a bottom sheet
   - slim sticky bar after scrolling
   - "All Products" button in the orange bar at 750-1200
   - "Fits your <model>" tags in product suggestions
   The vehicle stays in localStorage "VehicleSearchSelects" (make|model|sub|url),
   the same key scripts.js, layout/theme.liquid and header-search.liquid use.
   ========================================================================== */
(function () {
  if (window.dsHeaderV2) return;
  window.dsHeaderV2 = true;

  var KEY = 'VehicleSearchSelects';
  var PHONE = window.matchMedia('(max-width: 749px)');

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function raw() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }

  function saved() {
    var r = raw();
    if (!r) return null;
    var parts = r.split('|'), names = [], url = '';
    parts.forEach(function (x) {
      if (x && x.indexOf('/collections') === 0) url = x;
      else if (x && x.replace(/\s+/g, '')) names.push(x.trim());
    });
    if (names.length < 2) return null;
    var head = names[0] + '-' + names[1];
    var keys = [head], partial = true;
    if (names[2]) {
      var w = /^\(([^()]*)\)$/.exec(names[2]);
      var bare = w ? w[1].trim() : names[2];
      keys = [head + '-' + bare, head + '-(' + bare + ')'];
      partial = false;
    }
    return { make: names[0], model: names[1], sub: names[2] || '', url: url, keys: keys, partial: partial,
             label: names.join(' ').replace(/\s+/g, ' ').trim(), short: (names[0] + ' ' + names[1]).trim() };
  }
  function fits(v, list) {
    if (!v || !list) return false;
    return list.split('|').some(function (a) {
      a = a.trim();
      return v.keys.some(function (k) { return a === k || (v.partial && a.indexOf(k + '-') === 0); });
    });
  }

  /* ---------------- vehicle band ---------------- */
  var band, panel, savedBox;
  var STEPS = ['Make', 'Model', 'Sub model · optional'];

  function sels() {
    return [1, 2, 3].map(function (i) { return band ? q('.select-sort-' + i, band) : null; });
  }
  function chosen(sel, i) {
    if (!sel || sel.disabled) return false;
    var v = sel.value;
    return !!v && v !== ['Select Make', 'Select Model', 'Select Sub Model'][i];
  }
  function modelNode() {
    var s = sels();
    var data = window.searchJSON;
    if (!data || !chosen(s[0], 0) || !chosen(s[1], 1)) return null;
    var list = data[s[0].value] || [];
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i][s[1].value] != null) return list[i][s[1].value]; }
    return null;
  }
  function paintSteps() {
    var s = sels(), cur = false;
    s.forEach(function (sel, i) {
      if (!sel) return;
      var h = sel.closest('.search-by-vehicle-select-holder');
      if (!h) return;
      var done = chosen(sel, i);
      h.classList.toggle('is-done', done);
      var off = sel.disabled;
      h.classList.toggle('is-off', off && !done);
      var isCur = !done && !off && !cur;
      if (isCur) cur = true;
      h.classList.toggle('is-current', isCur);
    });
    var btn = band && q('.search-by-vehicle-btn', band);
    if (btn) btn.textContent = PHONE.matches ? 'Show parts' : (window.innerWidth < 990 ? 'Go' : 'Show parts');
    if (s[2] && s[2].options[0] && s[2].options[0].value === 'Select Sub Model' && s[2].options[0].textContent !== 'Any sub model') s[2].options[0].textContent = 'Any sub model';
    var mk = s[0] && s[0].value;
    qa('.ds-vband-makes button', band).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-make') === mk); });
  }
  function addStepLabels() {
    sels().forEach(function (sel, i) {
      if (!sel) return;
      var h = sel.closest('.search-by-vehicle-select-holder');
      if (!h || q('.ds-step', h)) return;
      var t = document.createElement('span');
      t.className = 'ds-step';
      t.setAttribute('aria-hidden', 'true');
      t.innerHTML = '<i>' + (i + 1) + '</i><em>' + STEPS[i] + '</em>';
      h.insertBefore(t, sel);
    });
    /* popular makes as one-tap chips (phone sheet only, hidden by CSS above 749px) */
    var holder = q('.search-by-vehicle-holder', band);
    if (holder && !q('.ds-vband-makes', band) && sels()[0]) {
      var wrap = document.createElement('div');
      wrap.className = 'ds-vband-makes';
      ['Toyota', 'Ford', 'Isuzu', 'Mitsubishi', 'Nissan', 'Mazda'].forEach(function (m) {
        if (!qa('option', sels()[0]).some(function (o) { return o.value === m; })) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = m;
        b.setAttribute('data-make', m);
        b.addEventListener('click', function () {
          var s1 = sels()[0];
          s1.value = m;
          s1.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(paintSteps, 0);
        });
        wrap.appendChild(b);
      });
      holder.parentNode.insertBefore(wrap, holder);
    }
  }
  function render() {
    if (!band) return;
    band.classList.remove('ds-pre');   // styled now: the picker can show
    var v = saved();
    var editing = band.classList.contains('is-editing');
    var st = v && !editing ? 'saved' : 'empty';
    band.setAttribute('data-state', v ? 'saved' : 'empty');
    if (savedBox) savedBox.hidden = st !== 'saved';
    if (panel) panel.hidden = st === 'saved';
    var title = q('[data-ds-open-title]', band), sub = q('[data-ds-open-sub]', band), arr = q('[data-ds-open-arr]', band);
    if (v) {
      qa('[data-ds-veh]', band).forEach(function (e) { e.textContent = v.label; });
      qa('[data-ds-model]', band).forEach(function (e) { e.textContent = v.model; });
      var all = q('[data-ds-all]', band);
      if (all) {
        if (v.url) { all.href = v.url; all.hidden = false; } else { all.hidden = true; }
      }
      if (title) title.textContent = v.label;
      if (sub) sub.textContent = 'Shopping for';
      if (arr) arr.textContent = 'Change';
    } else {
      if (title) title.textContent = 'Select your vehicle';
      if (sub) sub.textContent = 'See only parts that fit';
      if (arr && arr.textContent === 'Change') arr.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
    }
    paintSteps();
    stickRender();
  }
  function openSheet() {
    if (!band) return;
    band.classList.add('is-open', 'is-editing');
    var dim = q('.ds-vband-dim');
    if (dim) dim.hidden = false;
    document.documentElement.classList.add('ds-sheet-open');
    var o = q('.ds-vband-open', band);
    if (o) o.setAttribute('aria-expanded', 'true');
    render();
    var s = sels();
    var first = s.filter(function (x, i) { return x && !x.disabled && !chosen(x, i); })[0] || s[0];
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeSheet() {
    if (!band) return;
    band.classList.remove('is-open', 'is-editing');
    var dim = q('.ds-vband-dim');
    if (dim) dim.hidden = true;
    document.documentElement.classList.remove('ds-sheet-open');
    var o = q('.ds-vband-open', band);
    if (o) o.setAttribute('aria-expanded', 'false');
    render();
  }
  function startEditing() {
    if (PHONE.matches) { openSheet(); return; }
    band.classList.add('is-editing');
    render();
    var s1 = sels()[0];
    if (s1) setTimeout(function () { try { s1.focus(); } catch (e) {} }, 30);
  }

  /* Make + Model without a sub model: search the model instead of blocking with
     "Please select every option". A model that has no sub models at all goes straight
     to its collection. Runs in the capture phase so scripts.js never sees the click. */
  function onShowParts(e) {
    var btn = e.target.closest && e.target.closest('.search-by-vehicle-btn');
    if (!btn || !band || !band.contains(btn)) return;
    var s = sels();
    if (!chosen(s[0], 0) || !chosen(s[1], 1) || chosen(s[2], 2)) return;
    var node = modelNode();
    e.preventDefault();
    e.stopPropagation();
    if (typeof node === 'string' && node.indexOf('/collections') === 0) {
      try { localStorage.setItem(KEY, s[0].value + '|' + s[1].value + '||' + node); } catch (x) {}
      window.location.href = node;
      return;
    }
    try { localStorage.setItem(KEY, s[0].value + '|' + s[1].value + '||'); } catch (x) {}
    window.location.href = '/search?q=' + encodeURIComponent(s[0].value + ' ' + s[1].value) + '&options%5Bprefix%5D=last&type=product';
  }

  function initBand() {
    band = q('#DsVband');
    if (!band) return;
    panel = q('.ds-vband-panel', band);
    savedBox = q('.ds-vband-saved', band);
    addStepLabels();

    var open = q('.ds-vband-open', band);
    if (open) open.addEventListener('click', openSheet);
    var close = q('.ds-vband-close', band);
    if (close) close.addEventListener('click', closeSheet);
    var dim = q('.ds-vband-dim');
    if (dim) dim.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && band.classList.contains('is-open')) closeSheet(); });
    var chg = q('.ds-fitchip-chg', band);
    if (chg) chg.addEventListener('click', startEditing);
    // Clear on the saved chip (Ash, 3 Nov 2026: "where is clear"): the same as the band's own clear
    var clr = q('.ds-fitchip-clr', band);
    if (clr) clr.addEventListener('click', function () { var x = q('.search-by-vehicle-clear', band) || document.querySelector('.search-by-vehicle-clear'); if (x) x.click(); });

    band.addEventListener('change', function () { setTimeout(paintSteps, 0); });
    document.addEventListener('click', onShowParts, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && (e.target.closest('.search-by-vehicle-clear') || e.target.closest('.ds-nm-clear'))) {
        band.classList.add('is-editing');
        setTimeout(render, 0);
      }
    });
    window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
    if (PHONE.addEventListener) PHONE.addEventListener('change', function () { if (!PHONE.matches) closeSheet(); else render(); });
    window.addEventListener('resize', paintSteps);
    render();
    /* scripts.js fills Model / Sub Model at DOMContentLoaded and again on change */
    setTimeout(render, 300);
    setTimeout(render, 1500);
  }

  /* ---------------- "All Products" in the orange bar ---------------- */
  function initNavAll() {
    qa('.ds-nav-all').forEach(function (b) {
      b.addEventListener('click', function (e) {
        /* the theme closes the drawer on any outside click, so open it after this click has finished */
        e.preventDefault();
        e.stopPropagation();
        var t = q('#header .head-slot-nav-mobile-link');
        if (t) setTimeout(function () { t.click(); }, 0);
      });
    });
  }

  /* ---------------- slim sticky bar (shows once the vehicle band has scrolled off) ---------------- */
  var stick, stickVeh;
  var ICON_CAR = '<svg class="car" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17h14M3 13l2-5a2 2 0 0 1 2-1h10a2 2 0 0 1 2 1l2 5v4H3z"/><circle cx="7.5" cy="17" r="1.6"/><circle cx="16.5" cy="17" r="1.6"/></svg>';
  var ICON_OK = '<span class="ds-fitchip-ok" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-10"/></svg></span>';
  function stickRender() {
    if (!stickVeh) return;
    var v = saved();
    stickVeh.classList.toggle('is-saved', !!v);
    stickVeh.innerHTML = v ? ICON_OK + '<span>' + v.short.replace(/</g, '&lt;') + '</span>' : ICON_CAR + '<span>Select vehicle</span>';
  }
  function initSticky() {
    var header = q('#header');
    if (!header || q('.ds-stick')) return;
    var img = q('#header .header-heading img');
    var cartQty = q('#header .head-slot-cart-link-quantity');
    stick = document.createElement('div');
    stick.className = 'ds-stick';
    stick.setAttribute('aria-hidden', 'true');
    stick.innerHTML =
      '<div class="container ds-stick-in">' +
        '<button type="button" class="ds-stick-menu" aria-label="Menu" tabindex="-1"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg></button>' +
        '<a class="ds-stick-logo" href="/" tabindex="-1">' + (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="Direct Suspensions">' : 'Direct Suspensions') + '</a>' +
        '<form action="/search" method="get" role="search"><input type="search" name="q" placeholder="Search part number or product" aria-label="Search" tabindex="-1"><input type="hidden" name="options[prefix]" value="last"><button type="submit" aria-label="Search" tabindex="-1"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg></button></form>' +
        '<button type="button" class="ds-stick-veh" tabindex="-1"></button>' +
        '<a class="ds-stick-cart" href="/cart" aria-label="Cart" tabindex="-1"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 7H6"/></svg><span>' + (cartQty ? cartQty.textContent.trim() : '') + '</span></a>' +
      '</div>';
    document.body.appendChild(stick);
    stickVeh = q('.ds-stick-veh', stick);
    stickRender();
    stickVeh.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (band) setTimeout(startEditing, 350);
    });
    q('.ds-stick-menu', stick).addEventListener('click', function () {
      var t = q('#header .head-slot-nav-mobile-link');
      window.scrollTo({ top: 0 });
      if (t) setTimeout(function () { t.click(); }, 50);
    });
    q('.ds-stick-cart', stick).addEventListener('click', function (e) {
      var t = q('#mini-cart-toggle a');
      if (t) { e.preventDefault(); t.click(); }
    });
    if (cartQty && window.MutationObserver) {
      new MutationObserver(function () { q('.ds-stick-cart span', stick).textContent = cartQty.textContent.trim(); })
        .observe(cartQty, { childList: true, characterData: true, subtree: true });
    }

    var last = window.scrollY, ticking = false, on = false, thrAt = 0;
    /* measured once from the top of the page: the theme moves the header section (sticky +
       translateY) while scrolling, so its live position can't be used */
    function measure() {
      if (window.scrollY > 5 && thrAt) return;
      var b = band || header;
      thrAt = window.scrollY > 5 ? 420 : b.getBoundingClientRect().bottom + window.scrollY + 120;
    }
    function threshold() { if (!thrAt) measure(); return thrAt; }
    window.addEventListener('resize', function () { if (window.scrollY <= 5) measure(); });
    function set(v) {
      if (v === on) return;
      on = v;
      stick.classList.toggle('is-on', v);
      document.documentElement.classList.toggle('ds-stick-on', v);
      stick.setAttribute('aria-hidden', v ? 'false' : 'true');
      qa('a, button, input', stick).forEach(function (el) { el.tabIndex = v ? 0 : -1; });
    }
    function tick() {
      ticking = false;
      var y = window.scrollY, thr = threshold();
      if (document.documentElement.classList.contains('ds-sheet-open')) { last = y; return; }
      set(y >= thr);
      last = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }, { passive: true });
  }

  /* ---------------- Fits tags in product suggestions ---------------- */
  function markFits(root) {
    var v = saved();
    if (!v) return;
    qa('li[data-possible-vehicles]', root).forEach(function (li) {
      if (li.getAttribute('data-ds-fits-done')) return;
      li.setAttribute('data-ds-fits-done', '1');
      if (!fits(v, li.getAttribute('data-possible-vehicles'))) return;
      var c = q('.predictive-search-item-content', li);
      if (!c) return;
      var t = document.createElement('span');
      t.className = 'ds-fits';
      t.textContent = 'Fits your ' + v.model;
      var h = q('.predictive-search-item-heading', c);
      if (h && h.nextSibling) c.insertBefore(t, h.nextSibling); else c.appendChild(t);
    });
  }
  function initFits() {
    if (!window.MutationObserver) return;
    qa('[data-predictive-search]').forEach(function (box) {
      new MutationObserver(function () { markFits(box); }).observe(box, { childList: true, subtree: true });
    });
  }

  /* ---------------- search placeholder: says what the box finds ---------------- */
  function initPlaceholder() {
    var inputs = qa('#header .header-global-search-input');
    function setPh() {
      var t = 'Search by part';
      inputs.forEach(function (i) { if (!i.getAttribute('data-typewriter-primary')) i.placeholder = t; });
    }
    setPh();
    if (PHONE.addEventListener) PHONE.addEventListener('change', setPh);
  }

  function start() {
    initPlaceholder();
    initBand();
    initNavAll();
    initSticky();
    initFits();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
